module.exports = __webpack_public_path__ + "static/img/005.669006e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cooperator/005.png
// module id = Aty/
// module chunks = 0